// import '../App.css';
import Hero from '../components/Hero.js';
import Footer from '../components/Footer.js';
import Navbar from '../components/Navbar.js';
import { useEffect, useState } from 'react';

const Home = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const refParam = params.get('ref');
    if (refParam) {
      sessionStorage.setItem("referer", refParam)
    }
  }, []);
    return (
        <>
            <div className="background" style={{minHeight:"100vh"}} >
                <Navbar />
                <Hero />
            </div>
            <Footer />
        </>
    )
}
export default Home;